
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import implicitModules from "./-embroider-implicit-modules.js";


import * as amdModule0 from "./adapters/application.js"
import * as amdModule1 from "./config/environment.js"
import * as amdModule2 from "./initializers/current-user.js"
import * as amdModule3 from "./models/com-pais.js"
import * as amdModule4 from "./models/contrasena.js"
import * as amdModule5 from "./models/emp-parametros-generales.js"
import * as amdModule6 from "./models/empresa.js"
import * as amdModule7 from "./models/kar-parametro.js"
import * as amdModule8 from "./models/menu.js"
import * as amdModule9 from "./models/modulo.js"
import * as amdModule10 from "./models/parametro.js"
import * as amdModule11 from "./models/permiso-grupo.js"
import * as amdModule12 from "./models/permiso.js"
import * as amdModule13 from "./models/vf-perfil.js"
import * as amdModule14 from "./models/vf-user.js"
import * as amdModule15 from "./router.js"
import * as amdModule16 from "./serializers/application.js"
import * as amdModule17 from "./services/current-empresa.js"
import * as amdModule18 from "./services/current-user.js"
import * as amdModule19 from "./services/error-handler.js"
import * as amdModule20 from "./services/request.js"
import * as amdModule21 from "./services/session.js"
import * as amdModule22 from "./session-stores/application.js"
import * as amdModule23 from "./services/toast.js"
import * as amdModule24 from "./authenticators/jwt.js"
import * as amdModule25 from "./authenticators/token.js"
import * as amdModule26 from "./initializers/ember-simple-auth.js"
import * as amdModule27 from "./services/cookies.js"
import * as amdModule28 from "./services/page-title.js"
import * as amdModule29 from "./initializers/ember-data.js"
import * as amdModule30 from "./services/store.js"
import * as amdModule31 from "./transforms/date.js"
import * as amdModule32 from "./transforms/number.js"
import * as amdModule33 from "./transforms/string.js"
import * as amdModule34 from "./transforms/boolean.js"
import * as amdModule35 from "./data-adapter.js"
import * as amdModule36 from "./templates/application.hbs"
import * as amdModule37 from "./controllers/application.js"
import * as amdModule38 from "./routes/application.js"
import * as amdModule39 from "./routes/sirvo.js"
import * as amdModule40 from "./templates/sirvo/demos.hbs"
import * as amdModule41 from "./controllers/sirvo/demos.js"
import * as amdModule42 from "./routes/sirvo/demos.js"
import * as amdModule43 from "./templates/sirvo/empresas.hbs"
import * as amdModule44 from "./routes/sirvo/empresas.js"
import * as amdModule45 from "./templates/sirvo/index.hbs"
import * as amdModule46 from "./routes/sirvo/index.js"
import * as amdModule47 from "./templates/unauthorized.hbs"
import * as amdModule48 from "./routes/unauthorized.js"

let exportFastbootModules = {};





export default Object.assign(
  {},
  implicitModules,
  {
"ui-ember-vite/adapters/application": amdModule0,
"ui-ember-vite/config/environment": amdModule1,
"ui-ember-vite/initializers/current-user": amdModule2,
"ui-ember-vite/models/com-pais": amdModule3,
"ui-ember-vite/models/contrasena": amdModule4,
"ui-ember-vite/models/emp-parametros-generales": amdModule5,
"ui-ember-vite/models/empresa": amdModule6,
"ui-ember-vite/models/kar-parametro": amdModule7,
"ui-ember-vite/models/menu": amdModule8,
"ui-ember-vite/models/modulo": amdModule9,
"ui-ember-vite/models/parametro": amdModule10,
"ui-ember-vite/models/permiso-grupo": amdModule11,
"ui-ember-vite/models/permiso": amdModule12,
"ui-ember-vite/models/vf-perfil": amdModule13,
"ui-ember-vite/models/vf-user": amdModule14,
"ui-ember-vite/router": amdModule15,
"ui-ember-vite/serializers/application": amdModule16,
"ui-ember-vite/services/current-empresa": amdModule17,
"ui-ember-vite/services/current-user": amdModule18,
"ui-ember-vite/services/error-handler": amdModule19,
"ui-ember-vite/services/request": amdModule20,
"ui-ember-vite/services/session": amdModule21,
"ui-ember-vite/session-stores/application": amdModule22,
"ui-ember-vite/services/toast": amdModule23,
"ui-ember-vite/authenticators/jwt": amdModule24,
"ui-ember-vite/authenticators/token": amdModule25,
"ui-ember-vite/initializers/ember-simple-auth": amdModule26,
"ui-ember-vite/services/cookies": amdModule27,
"ui-ember-vite/services/page-title": amdModule28,
"ui-ember-vite/initializers/ember-data": amdModule29,
"ui-ember-vite/services/store": amdModule30,
"ui-ember-vite/transforms/date": amdModule31,
"ui-ember-vite/transforms/number": amdModule32,
"ui-ember-vite/transforms/string": amdModule33,
"ui-ember-vite/transforms/boolean": amdModule34,
"ui-ember-vite/data-adapter": amdModule35,
"ui-ember-vite/templates/application": amdModule36,
"ui-ember-vite/controllers/application": amdModule37,
"ui-ember-vite/routes/application": amdModule38,
"ui-ember-vite/routes/sirvo": amdModule39,
"ui-ember-vite/templates/sirvo/demos": amdModule40,
"ui-ember-vite/controllers/sirvo/demos": amdModule41,
"ui-ember-vite/routes/sirvo/demos": amdModule42,
"ui-ember-vite/templates/sirvo/empresas": amdModule43,
"ui-ember-vite/routes/sirvo/empresas": amdModule44,
"ui-ember-vite/templates/sirvo/index": amdModule45,
"ui-ember-vite/routes/sirvo/index": amdModule46,
"ui-ember-vite/templates/unauthorized": amdModule47,
"ui-ember-vite/routes/unauthorized": amdModule48,
  },
  exportFastbootModules
);
